import { defineMessages } from 'react-intl';

import type { AccountError } from '@/graphql/saleor/api';

import { commonErrorCodeMessages, type FormattedError } from './common';

export const errors = defineMessages({
  accountAlreadyExist: {
    id: 'myAccount.accountAlreadyExist',
    defaultMessage: 'Account already exists.',
  },
});

export const getAccountSignUpErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'UNIQUE':
      return errors.accountAlreadyExist;

    default:
      return commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
